import styled from 'styled-components'
import { GridMixin, FlexColumn, PaddingContainer } from 'components/common/common_styles'
import { sizeMobile, gutter } from 'components/globalStyles'
import SelectionArrows from 'components/common/selectionArrows'
import Fader from 'components/common/fader'

export const MainContainer = styled(PaddingContainer)`
  ${GridMixin};
  grid-template-columns: 1fr minmax(auto, 45%);
  grid-template-areas:
    'image title'
    'image body'
    'arrows body'
    '. body';
  row-gap: 32px;
  width: 100%;

  @media (max-width: ${sizeMobile}) {
    grid-template-columns: 100%;
    grid-template-areas:
      'title'
      'image';
  }
`

export const TitleContainer = styled.h2`
  grid-area: title;

  @media (max-width: ${sizeMobile}) {
    padding-left: ${gutter};
    padding-right: ${gutter};
  }
`

export const BodyContainer = styled(FlexColumn)`
  width: fit-content;
  max-width: 55ch;
  min-width: 30ch;
  transition: opacity 0.25s;

  & h3 {
    text-indent: -0.5ch;
  }

  @media (max-width: ${sizeMobile}) {
    width: 100%;
    max-width: ${props => (props.maxWidth ? `${props.maxWidth}px` : 'none')};
    min-width: 0;
    margin-top: 32px;

    .swiper-slide-next & {
      opacity: 0;
    }

    .swiper-slide-prev & {
      opacity: 0;
    }
  }
`

export const Carousel = styled.div`
  grid-area: image;
  width: 100%;
`

export const ImageFader = styled(Fader)`
  grid-area: image;
  justify-self: end;
`

export const BodyFader = styled(Fader)`
  grid-area: body;
`

export const ArrowContainer = styled(SelectionArrows)`
  grid-area: arrows;
  justify-self: end;
`

export const PaginationContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 24px;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${props => props.$top}px;
`